import React, {createContext, useReducer} from 'react';
import {PropertiesReducer, initial_state} from "../reducers/properties";

export const PropertiesContext = createContext();
export const PropertiesDispatcherContext = createContext();

export default function PropertiesProvider({children}) {
    const [propertiesState, propertiesDispatch] = useReducer(PropertiesReducer, initial_state);

    return (
        <PropertiesContext.Provider value={propertiesState}>
            <PropertiesDispatcherContext.Provider value={propertiesDispatch}>
                {children}
            </PropertiesDispatcherContext.Provider>
        </PropertiesContext.Provider>
    )
}